export const NoModuleFound = () => {
  return (
    <div className="container">
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="text-center">
          <h2>
            <i className="fa-solid fa-triangle-exclamation text-warning pe-2"></i>
            CRM Modules Not Activated
          </h2>
          <div>
            <p style={{ maxWidth: "700px" }}>
              Your crm related modules are not activated. Please activate your
              CRM modules such as FlightForm, Hotels, VisaEnquiry to use CRM
              service.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
